import { User } from 'oidc-client-ts';
import { identity, indexBy, pathOr, pipe } from 'ramda';
import { useMemo } from 'react';
import { useAuth } from 'react-oidc-context';
import { Union } from 'ts-toolbelt';

const getRolesFromUser = pathOr<string[]>([], ['profile', 'https://hasura.io/jwt/claims', 'x-hasura-allowed-roles']);

const getRolesMap = pipe<[Union.Nullable<User>], string[], Record<string, string>>(
  //
  getRolesFromUser,
  indexBy(identity),
);

export interface UseAuthRolesResult {
  hasRole: (role: string) => boolean;
  hasAnyRole: (roleList: string[]) => string | undefined;
}

export const useAuthRoles = (): UseAuthRolesResult => {
  const { user } = useAuth();

  return useMemo(() => {
    const roles = getRolesMap(user);
    return {
      hasRole: (role: string) => {
        return !!roles[role];
      },
      hasAnyRole: (roleList) => {
        return roleList.find((role) => roles[role]);
      },
    } as UseAuthRolesResult;
  }, [user]);
};
